import { Box } from 'theme-ui';

import { convertAlignToFlex } from '@utils';
import { Markdown } from '@snippets';

import { themed } from './Header.theme';

export const Header = themed(({ theme, text }) => {
  const headingText = text?.heading || '# Blog';

  const justifyContentArr = [
    convertAlignToFlex(text?.alignment),
    convertAlignToFlex(text?.alignment),
    convertAlignToFlex(text?.alignmentDt),
    convertAlignToFlex(text?.alignmentDt),
  ];

  const alignItemsArr = [
    convertAlignToFlex(text?.alignment),
    convertAlignToFlex(text?.alignment),
    convertAlignToFlex(text?.alignmentDt),
    convertAlignToFlex(text?.alignmentDt),
  ];

  const textAlignArr = [
    text?.alignment,
    text?.alignment,
    text?.alignmentDt,
    text?.alignmentDt,
  ];

  return (
    <Box
      data-comp={Header.displayName}
      sx={{
        ...theme.header,
        justifyContent: justifyContentArr,
        alignItems: alignItemsArr,
      }}
    >
      <Markdown
        textSx={{
          ...theme.heading,
          textAlign: textAlignArr,
        }}
      >
        {headingText}
      </Markdown>
    </Box>
  );
});

Header.displayName = 'Header';
